import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NotificationHistoryItem } from '../../models/notification-history';

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

interface PagedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  hasNext: boolean;
}

export interface NotificationHistoryParams {
  category?: string;
  search?: string;
  page?: number;
  size?: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationHistoryService {
  private baseUrl = `${environment.url}/customer-notifications/campaigns`;
  private http = inject(HttpClient);

  getHistory(params: NotificationHistoryParams = {}): Observable<ApiResponse<PagedResponse<NotificationHistoryItem>>> {
    let httpParams = new HttpParams();
    if (params.category) httpParams = httpParams.set('category', params.category);
    if (params.search)   httpParams = httpParams.set('search', params.search);
    if (params.page != null) httpParams = httpParams.set('page', String(params.page));
    if (params.size != null) httpParams = httpParams.set('size', String(params.size));
    return this.http.get<ApiResponse<PagedResponse<NotificationHistoryItem>>>(this.baseUrl, { params: httpParams });
  }

  getCampaign(campaignId: number): Observable<ApiResponse<NotificationHistoryItem>> {
    return this.http.get<ApiResponse<NotificationHistoryItem>>(`${this.baseUrl}/${campaignId}`);
  }
}
